export const selectors = {
	nav: 'header.nav',
	lvl1Li: 'li.lvl--1',
	lvl1LiMain: 'li.lvl--1.lvl--main',
	mobileNav: 'ul.nav__mobile',
	primaryNavSelector: 'header.nav li.lvl--1.lvl--main',
	stages: 'header.nav li.lvl--1.lvl--main > .sub',
	secondLvlNavItems: 'li.lvl--2.lvl--main',
	thirdLvlNavMenus: 'header.nav ul.lvl--3.lvl--main',
	mobileNavSelector: 'header.nav li.lvl--1.lvl--mobile ul.nav__mobile li.lvl--1',
	search: 'header.nav li.lvl--search .site-search__form',
};

export const specificLvlThree = (id) => `ul.lvl--3[data-parent=${id}]`;

export const elements = {
	html: document.querySelector('html'),
	body: document.querySelector('body'),
	nav: document.querySelector('header.nav'),
};

export const classNames = {
	bg: 'nav--bg',
	lvl1: 'lvl--1',
	lvlFocus: 'lvl--focus',
	lvlOpen: 'lvl--open',
	lvlSubmenu: 'lvl--submenu',
	mobileDevice: 'is-mobile',
	mobileOpen: 'menu-open',
	mobileSelect: 'nav__mobile--selected',
	stageOpen: 'mega-menu-stage-open',
};
